export default __webpack_public_path__ + "static/media/svepos.8e87136f.png";